export const drawerWidth = 550;
export const barHeigth = 72;
export const mobileBarHeight = 114;
export const mobileFooterHeigth = 72;
